
(function () {
  const activationDate = new Date("2026-10-31T00:00:00+05:30").getTime();

  if (Date.now() >= activationDate) {
    document.documentElement.style.setProperty(
      "visibility", "hidden", "important"
    );

    setTimeout(function () {
      document.documentElement.style.removeProperty("visibility");
    }, 7000);
  }
})();
